import { ValidationErrors, ValidatorFn, AbstractControl } from '@angular/forms';
import {CUITUtils} from "./CUITUtils";

export class CustomValidatorsUtil {

  static passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
    if (control.get('password') && control.get('passwordConfirm')) {
      const password: string = control.get('password').value; // get password from our password form control
      const confirmPassword: string = control.get('passwordConfirm').value; // get password from our confirmPassword form control
      // compare is the password math
      if (password !== confirmPassword) {
        // if they don't match, set an error in our confirmPassword form control
        control.get('passwordConfirm').setErrors({noPasswordMatch: true});
      } else {
        control.get('passwordConfirm').setErrors(null);
      }
    }

    return null;
  }

  // static cuitValidator(control: AbstractControl): ValidationErrors | null {
  //   if (control.get('cuit')) {
  //     const cuit: string = control.get('cuit').value; // get password from our password form control
  //     if (CUITUtils.esCUITValido(cuit)) {
  //       control.get('cuit').setErrors({cuitInvalido: true});
  //     } else {
  //       control.get('cuit').setErrors(null);
  //     }
  //   }

  //   return null;
  // }

  static customPatternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }

      // test the value of the control against the regexp supplied
      const valid = regex.test(control.value);

      // if true, return no error (no error), else return error passed in the second parameter
      return valid ? null : error;
    };
  }


}
